import { promptHelpers } from '@/api/chatGPT/promptHelpers'

export const promptHelpersEvents = {
  requestNewDiagram (workflow, requirementTypes, description) {
    return `${promptHelpers.backgroundEntities(workflow.dataModels)}
**Request:**
This request covers the first two steps of seven in Event Modeling: brainstorming events and arranging them on a timeline. Your task is to list all the state-changing events in chronological order based on the "Workflow Description" (a business process or project scope). A state-changing event is an actor invoking a state-changing command (create, update or delete) on an aggregate. Each step must include the following:
- **Role:** The actor (a human or a system if the step is automated) invoking the command, with a maximum length of 18 characters.
- **Event Description:** A description of the state-changing event using a verb in past tense and noun (the noun is the aggregate being created, updated, or deleted), with a maximum length of 40 characters.

**Workflow Description:**
\`${description}\`

**Formatting:**
The result should be formatted as a valid JSON array, like this example:

\`\`\`json
[
  {"role": "Customer", "description": "Created order"},
  {"role": "Support", "description": "Resolved issue"},
  {"role": "Supplier", "description": "Scheduled delivery"}
]
\`\`\`

**Note:**
- Ensure role names and descriptions are concise and within the character limits.
- If the "Workflow Description" is unclear, make reasonable assumptions.
- State-changing events are actions or commands that alter the state of an aggregate. For example, "Created order" or "Approved invoice" are state-changing events, while actions like "Page viewed" are not, as they do not alter the state of an aggregate.
- The name of the aggregate (e.g. order, issue, delivery) should align with how it would be named in a business process. For example, use "Picked up delivery" or "Picked up shipment" rather than "Picked up food" or "Picked up package".
`
  },

  requestAddOneStep (workflow, currentDiagram, currentStep) {
    let res = ''
    res += '**Request:**\n'
    res += `Suggest one more step, after step ${currentStep}`
    if (currentDiagram[currentStep]) {
      res += ` and before step ${currentStep + 1}`
    }
    res += ', that is relevant to the business process, workflow or project scope. '
    res += `The step must reflect what is typically happening in the process (a command invoked by an actor on an aggregate), after step ${currentStep} (${currentDiagram[currentStep - 1].role} - ${currentDiagram[currentStep - 1].description})`
    if (currentDiagram[currentStep]) {
      res += ` and before ${currentStep + 1} (${currentDiagram[currentStep].role} - ${currentDiagram[currentStep].description})`
    }
    res += '. '
    res += this.roleAndDescriptionInstruction(true)
    res += '\n\n'
    return res
  },

  roleAndDescriptionInstruction (onlyOneCard = false) {
    let res = ''
    if (onlyOneCard) {
      res += 'The step '
    } else {
      res += 'Each step '
    }
    res += 'must contain the role, actor or system name (if automated) with the max length of 18 characters. '
    if (onlyOneCard) {
      res += 'The step '
    } else {
      res += 'Each step '
    }
    res += 'must contain the description of the event with the max length of 40 characters, '
    res += 'the description should contain a verb in past tense and a noun.'
    return res
  }
}
